import { vaultGetRequest } from '../helpers';
import type { IListCropsResponse } from './list-crops-response';
import { listCropsResponseSchema } from './list-crops-response';

export async function listCropsApi(path: string): Promise<IListCropsResponse> {
  return vaultGetRequest({
    path: `/crop?path=${encodeURIComponent(path)}`,
    schema: listCropsResponseSchema,
  });
}
